
// 获取登录用户信息
export const userInfo = state => state.userInfo

// 获取登录状态
export const isLogin = state => state.isLogin

// 获取租户信息
export const companyInfo = state => state.companyInfo

// 获取token过期时间
export const tokenTimeout = state => state.tokenTimeout

// 租户Id
export const tenantId = state => state.tenantId

// 租户Id
export const chatNum = state => state.chatNum

// 分类
export const classification = state => state.classification
// 获取图片来源拼接地址
export const ossFileUrl = state => state.ossFileUrl

// 获取用户表格列设置
export const userColumnsSetting = state => state.userColumnsSetting
